var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
var Component = function () { return (_jsxs("svg", __assign({ width: "13", height: "14", viewBox: "0 0 13 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [_jsx("path", { d: "M3.27148 3.47644L5.97194 1.00002L8.6724 3.47644", stroke: "#69717F", "stroke-width": "1.00189", "stroke-miterlimit": "10", "stroke-linecap": "square" }), _jsx("path", { d: "M6.02657 1.45235L6.02719 12.5061", stroke: "#69717F", "stroke-width": "1.00189", "stroke-miterlimit": "10", "stroke-linecap": "square" }), _jsx("path", { d: "M8.6724 10.6699L5.97194 13.1463L3.27148 10.6699", stroke: "#69717F", "stroke-width": "1.00189", "stroke-miterlimit": "10", "stroke-linecap": "square" })] }))); };
export default Component;
